import React from "react";
import { useScreen } from "../providers/ScreenProvider";

function Slider({ children, config }) {
  const screen = useScreen();

  const trackRef = React.useRef();

  const [trackOffset, setTrackOffset] = React.useState(0);
  const [trackWidth, setTrackWidth] = React.useState(0);
  const [slideWidth, setSlideWidth] = React.useState(0);
  const [scrollWidth, setScrollWidth] = React.useState(0);
  const [numSlides, setNumSlides] = React.useState(config.slidesToShow);

  React.useEffect(() => {
    if (children.length) {
      init();
    }
  }, [children, screen.width]);

  React.useEffect(() => {
    if (children.length) {
      setTrackOffset(0);
    }
  }, [children.length]);

  const init = () => {
    if (trackRef.current) {
      checkBreakpoints();
      const slides = trackRef.current.children;
      const slideRect = slides[0].getBoundingClientRect();
      setSlideWidth(slideRect.width);
      setTrackWidth(slideRect.width * children.length);
      setScrollWidth(slideRect.width * (config.slidesToScroll || 1));
    }
  };

  const checkBreakpoints = () => {
    if (config.breakpoints) {
      let num;
      for (const breakpoint of config.breakpoints) {
        if (window.innerWidth < breakpoint.width) {
          num = breakpoint.slidesToShow;
        }
      }
      setNumSlides(num ? num : config.slidesToShow);
    }
  };

  const handlePrev = () => {
    const limit = 0;
    setTrackOffset(trackOffset + scrollWidth <= limit ? trackOffset + scrollWidth : limit);
  };

  const handleNext = () => {
    const limit = (trackWidth - numSlides * slideWidth) * -1;
    setTrackOffset(trackOffset - scrollWidth >= limit ? trackOffset - scrollWidth : limit);
  };

  return (
    <>
      {!!children.length && (
        <div
          style={{
            position: "relative",
          }}
        >
          <div
            ref={trackRef}
            style={{
              display: "grid",
              grid: `auto/repeat(100, ${100 / numSlides}%)`,
              transform: `translate3d(${trackOffset}px, 0px, 0px)`,
              transition: "transform 100ms ease",
            }}
          >
            {children.map((child, index) => (
              <div
                key={index}
                style={{
                  padding: config.spacing,
                }}
              >
                {child}
              </div>
            ))}
          </div>
          {trackOffset < 0 && (
            <button
              type="button"
              style={{
                position: "absolute",
                top: "50%",
                left: config.spacing * -1,
                transform: "translateY(-50%)",
                padding: "5px",
              }}
              onClick={handlePrev}
            >
              <svg viewBox="0 0 20 20" fill="currentColor" width={30}>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z"
                />
              </svg>
            </button>
          )}
          {trackOffset > (trackWidth - numSlides * slideWidth) * -1 && (
            <button
              type="button"
              style={{
                position: "absolute",
                top: "50%",
                right: config.spacing * -1,
                transform: "translateY(-50%)",
                padding: "5px",
              }}
              onClick={handleNext}
            >
              <svg viewBox="0 0 20 20" fill="currentColor" width={30}>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                />
              </svg>
            </button>
          )}
        </div>
      )}
    </>
  );
}

Slider.defaultProps = {
  config: {
    slidesToShow: 3,
    slidesToScroll: 1,
    spacing: 10,
    breakpoints: [],
  },
};

export default Slider;
